import {API_URL} from "../../../Constants";

export const getUsersBySchoolAndPosition = () => {
    return API_URL + "/user/bySchoolAndPosition";
}

export const getUsersByOrganizationAndPosition = () => {
    return API_URL + "/user/byOrganizationAndPosition"
}